// 需要全局注册的自定义指令
import debounce from './debounce'
import waves from './waves'
import blur from './blur'
import emoji from './emoji'
import hmt from './hmt'

const directives = {
  debounce, // 防抖
  waves, // 按钮波纹效果
  blur,
  emoji, // 禁止输入框emoji
  hmt // 百度统计
}

export default {
  install(Vue) {
    Object.keys(directives).forEach((key) => {
      Vue.directive(key, directives[key])
    })
  }
}
